import OrderDetailsArrowLeft from "@NA/Icons/OrderDetailsArrowLeft";
import PrintIcon from "@NA/Icons/PrintIcon";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import translate from "@insite/client-framework/Translate";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useEffect } from "react";
import { css } from "styled-components";

interface OwnProps {
    quoteDetails?: OrderModel;
}

type Props = OwnProps & HasHistory;

export interface ADIRfqQuoteDetailsTitleHeaderStyles {
    quotesPageHeaderContainer?: InjectableCss;
    pageTitleSection?: InjectableCss;
    titleText: TypographyProps;
    wrapper?: InjectableCss;
    returnButtonWrapper?: InjectableCss;
    printButton?: ButtonPresentationProps;
    returnButton?: ButtonPresentationProps;
    returnButtonMobile?: ButtonPresentationProps;
}

export const adiRfqQuoteDetailsTitleHeaderStyles: ADIRfqQuoteDetailsTitleHeaderStyles = {
    quotesPageHeaderContainer: {
        css: css`
        width: 100%;
        `
    },
    pageTitleSection: {
        css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        `
    },
    titleText: {
        variant: "h2",
        css: css`
            font-size: 28px;
            line-height: .93;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            margin: 0;
            background-color: transparent;
            @media only screen and (max-width: 1024px) {
                font-size: 36px;
                font-weight: 700;
                line-height: 38px;
                margin-top: 2px;
            }
            @media print{
                color: ${ADIColors.black};;
            }
            @media only screen and (max-width: 576px) {
                font-size: 24px;
                line-height: 31px;
                padding-top: 0px;
                padding-bottom: 0px;
                margin-top: 0px;
            }
        `
    },
    wrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: nowrap;
            flex-direction: row;
            margin-top: 0;
            margin-bottom: 0;
            @media only screen and (max-width: 576px) {
                display: none;
            }
        `,
    },
    returnButtonWrapper: {
        css: css`
        display: inline-flex;
        align-items: center;
        `
    },
    printButton: {
        variant: "secondary",
        css: css`
            margin-left: 20px;
            width: auto;
            min-width: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            border: solid 1px ${getColor("secondary")};
            background: ${getColor("common.background")};
            padding: 0 13px;
            svg{
                height: 20px;
                width: 20px;
            }
            &:focus{
                outline: none;
            }
            &:hover{
                background: ${ADIColors.darkBlue6} !important;
                color: ${ADIColors.blue1} !important;
            }
            @media only screen and (max-width: 1024px) {
                display: none;
            }
        `
    },
    returnButton: {
        variant: "secondary",
        css: css`
            min-width: 226px;
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            justify-content: center;
            border-radius: 4px;
            border: solid 1px ${getColor("secondary")};
            background: ${getColor("common.background")};
            svg{
                margin-right: 10px;
                height: 10px;
                width: 13px;
            }
            &:focus{
                outline: none;
            }
            &:hover{
                background: ${ADIColors.darkBlue6} !important;
                color: ${ADIColors.blue1} !important;
            }
            @media only screen and (max-width: 1024px) {
                display: none;
            }
        `
    },
    returnButtonMobile: {
        variant: "secondary",
        css: css`
            width: auto;
            min-width: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            border: solid 1px ${getColor("secondary")};
            background: ${getColor("common.background")};
            padding: 0 12px;
            display: none;
            svg{
                height: 13px;
                width: 16px;
            }
            &:focus{
                outline: none;
            }
            &:hover{
                background: ${ADIColors.darkBlue6} !important;
                color: ${ADIColors.blue1} !important;
            }
            
            @media only screen and (max-width: 1024px) {
                display: flex;
            }
        `
    },
};

const styles = adiRfqQuoteDetailsTitleHeaderStyles;

const ADIRfqQuoteDetailsTitleHeader: FC<Props> = ({
    history,
    quoteDetails
}) => {
    const onClick = () => {
        history.push("/MyAccount/MyQuotes");
    };

    const onClickPrint = () => {
        openPrintDialog();
    };
    const [id, setId] = React.useState('');
    
    const projectStatus = quoteDetails?.properties["projectStatus"] === "Y";

    return (
        <StyledWrapper {...styles.quotesPageHeaderContainer}>
            <StyledWrapper {...styles.pageTitleSection}>
                <Typography {...styles.titleText}>
                    {projectStatus && <span>{translate("Project Quote ")}{quoteDetails?.erpOrderNumber}</span>}
                    {!(projectStatus) && <span>{translate("Quote ")}{quoteDetails?.erpOrderNumber}</span>}
                </Typography>
                <StyledWrapper {...styles.wrapper}>
                    <StyledWrapper {...styles.returnButtonWrapper}>
                        <Button onClick={onClick} {...styles.returnButton}>
                            <OrderDetailsArrowLeft />
                            {translate("Return to My Quotes")}
                        </Button>
                        <Button onClick={onClick} {...styles.returnButtonMobile}>
                            <OrderDetailsArrowLeft />
                        </Button>
                        {!(quoteDetails?.orderLines?.length === 0) &&
                            <Button {...styles.printButton} onClick={onClickPrint}>
                                <PrintIcon />
                            </Button>
                        }
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    )
};

export default withHistory(ADIRfqQuoteDetailsTitleHeader);
